module.exports = __webpack_public_path__ + "static/doors_night_mobile-9222e1bae059d3b42f2c3014336ef2a6.jpg";